import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Box, HBox } from "@ui/box/Box";
import { IconApple } from "src/assets/terminal/icon_apple";
import { IconBank } from "src/assets/terminal/icon_bank";
import { IconCard } from "src/assets/terminal/icon_card";
import { IconGoogle } from "src/assets/terminal/icon_google";
import { IconOct } from "../../assets/terminal/icon_oct";
import { ITerminal } from "src/types/types";

export const TerminalBadge = ({
	terminal,
	size,
	padding,
	simple,
	invert,
}: {
	invert?: boolean;
	terminal: ITerminal;
	size?: number;
	padding?: number;
	simple?: boolean;
}) => {
	useLocale();
	const badgeSize = size ?? 35;
	const badgePadding = padding ?? 14;
	let icon = null;
	if (!terminal) {
		terminal = {
			id: 0,
			name: msg("unknown"),
			type: null,
			icon: "",
			created_at: 0,
			updated_at: 0,
			status: "deleted",
		};
	}
	if (typeof terminal === "string") {
		terminal = {
			id: 0,
			name: msg("unknown"),
			type: terminal,
			icon: "",
			created_at: 0,
			updated_at: 0,
			status: "deleted",
		};
	}

	switch (terminal.type) {
		case "oct":
			icon = <IconOct size="30px" />;
			break;

		case "payment_card":
			icon = <IconCard size="30px"/>;
			break;

		case "apple_pay":
			icon = <IconApple size="30px"/>;
			break;

		case "google_pay":
			icon = <IconGoogle size="30px"/>;
			break;

		case "open_banking":
			icon = <IconBank size="30px"/>;
			break;

		default:
			break;
	}

	return (
		<HBox
			sx={{
				alignItems: "center",
				width: `${badgeSize}px`,
				height: `${badgeSize}px`,
				justifyContent: "center",
				backgroundColor: simple ? "transparent" : "#d8d9e2",
				borderRadius: simple ? undefined : "50%",
			}}>
			<Box
				sx={{
					alignItems: "center",
					display: "flex",
					width: `${badgeSize - badgePadding}px`,
					filter: invert ? "invert(1)" : undefined,
					height: `${badgeSize - badgePadding}px`,
				}}>
				{icon}
			</Box>

			{/* <Typo variant="medium" sx={{ color: "#FFFFFF" }}>
				{label}
			</Typo> */}
		</HBox>
	);
};
